import { Component } from '@angular/core';

@Component({
  selector: 'false-confirm',
  templateUrl: './confirm.component.html',
  styles: [
  ]
})
export class ConfirmComponent {

}
